import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/browser';
import { App } from './App';
import { CustomBrowserRouter } from './routes/CustomBrowserRouter';
import './index.css';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_KEY,
  enabled: process.env.NODE_ENV === 'production'
});

ReactDOM.render(
  <HelmetProvider>
    <CustomBrowserRouter>
      <App />
    </CustomBrowserRouter>
  </HelmetProvider>,
  document.getElementById('root')
);
